export const INTERVAL_TYPES = {
    choices: () => {
        // continuo, simple, compuesto
        return ["con", "sim", "com"]
    },
    values: {
        con: ["h_start", "min_measure", "num_pub", "interval_send"], // continuo
        sim: ["h_start", "min_measure", "num_pub", "num_measures", "interval_send"], // simple
        com: ["h_start", "min_measure", "num_pub", "num_measures", "min_measure_b", "interval_send"] // compuesto
    }
}
